import './App.css'
import { Route, Routes, HashRouter as BrowserRouter } from "react-router-dom";
// Rutas generales
import Home from './pages/landing/Home';
import ScrollToTop from './components/common/ScrollToTop';

const App = () => {

  return (
    <>
      <div className='App'>
        <BrowserRouter>
        <ScrollToTop/>
          <Routes>
            <Route path='/' element={<Home/>}/>
          </Routes>
        </BrowserRouter>
      </div>
    </>
  )
}

export default App